import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "10",
      cy: "10",
      r: "9",
      transform: "rotate(90 10 10)",
      fill: "#EFF1F9"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.7071 5.29289C12.0976 5.68342 12.0976 6.31658 11.7071 6.70711L8.41421 10L11.7071 13.2929C12.0976 13.6834 12.0976 14.3166 11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071L6.29289 10.7071C5.90237 10.3166 5.90237 9.68342 6.29289 9.29289L10.2929 5.29289C10.6834 4.90237 11.3166 4.90237 11.7071 5.29289Z",
      fill: "#25262A"
    }, null, -1)
  ]))]))
}
export default { render: render }